<template>
  <div class="vehiclesList">
    <div class="searchTop">
      <van-row type="flex" align="center" class="search-top-row">
        <van-col class="colItem1">
          <van-search
            v-model="searchText"
            show-action
            shape="round"
            background="transparent"
            :placeholder="getPlaceHolder()"
          >
            <template #action>
              <div @click="onSearch">{{ $t.meta.search }}</div>
            </template>
          </van-search>
        </van-col>
        <van-col class="colItem2">
          <div :class="isFilter() ? 'isFilter' : ''">
            <span @click="showFilter = true">{{ $t.meta.filter }}</span>
          </div>
        </van-col>
      </van-row>
    </div>

    <van-list
      class="list"
      v-model="loading"
      :finished="finished"
      :finished-text="$t.meta.noMore"
      :error.sync="error"
      :error-text="errorText"
      @load="getList(page + 1)"
    >
      <div class="list-container" v-for="(item, index) in tableData" :key="index">
        <div class="checkBox">
          <van-checkbox v-model="item.isSelected" @change="handleCheckBox"></van-checkbox>
        </div>
        <div class="container">
          <div class="list-item">{{ $t.vehicles.vin }}：{{ item.VIN }}</div>
          <div class="list-item">{{ $t.vehicles.plate }}：{{ item.LicensePlate }}</div>
          <div class="list-item">{{ $t.vehicles.brand }}：{{ item.Brand }}</div>
          <div class="list-item">{{ $t.vehicles.model }}：{{ item.Model }}</div>
          <div class="list-item">
            {{ $t.vehicles.vehicleType }}：{{ item.VehicleType }}
          </div>
          <div class="list-item">{{ $t.vehicles.color }}：{{ item.Color }}</div>
          <div class="list-item">{{ $t.vehicles.dimensions }}：{{ item.Dimensions }}</div>
          <div class="list-item">{{ $t.vehicles.maxLoad }}：{{ item.MaxLoad }}</div>
          <div class="list-item">
            {{ $t.vehicles.vehicleStatus }}：
            <span v-if="item.VehicleStatus == 1">{{ $t.vehicles.vStatus1 }}</span>
            <span v-if="item.VehicleStatus == 2">{{ $t.vehicles.vStatus2 }}</span>
            <span v-if="item.VehicleStatus == 3">{{ $t.vehicles.vStatus3 }}</span>
            <span v-if="item.VehicleStatus == 4">{{ $t.vehicles.vStatus4 }}</span>
          </div>
          <div class="buttons">
            <van-button
              class="primary-btn"
              size="small"
              type="primary"
              @click="gotoDetail(item.VehicleId)"
              >{{ $t.meta.editButton }}</van-button
            >

            <van-button
              class="danger-btn"
              size="small"
              type="primary"
              @click="dialogDeleteShow(item.VehicleId)"
              >{{ $t.meta.delete }}</van-button
            >
          </div>
        </div>
      </div>
    </van-list>

    <van-popup
      v-model="showFilter"
      position="bottom"
      :style="{ height: '80%', width: '100%' }"
    >
      <div class="popup-header">{{ $t.meta.allFilter }}</div>
      <van-form>
        <div class="radio-label">{{ $t.meta.searchType }}</div>
        <van-radio-group v-model="searchType" direction="horizontal">
          <van-radio
            :name="item.value"
            v-for="(item, index) in searchTypeOptions"
            :key="index"
            >{{ item.text }}</van-radio
          >
        </van-radio-group>

        <div class="radio-label">{{ $t.vehicles.vehicleStatus }}</div>
        <van-radio-group v-model="vehicleStatus" direction="horizontal">
          <van-radio :name="1">{{ $t.vehicles.vStatus1 }}</van-radio>
          <van-radio :name="2">{{ $t.vehicles.vStatus2 }}</van-radio>
          <van-radio :name="3">{{ $t.vehicles.vStatus3 }}</van-radio>
          <van-radio :name="4">{{ $t.vehicles.vStatus4 }}</van-radio>
        </van-radio-group>

        <div class="custom-date">
          <div class="date-label">{{ $t.meta.date }}</div>
          <van-button class="date-btn1" type="info" size="small" @click="showStartDate">{{
            $t.meta.beginDate
          }}</van-button>
          <van-button class="date-btn2" type="info" size="small" @click="showEndDate">{{
            $t.meta.endDate
          }}</van-button>
          <div class="date-txt" v-if="beginTime || endTime">
            {{ beginTime }} {{ $t.meta.to }} {{ endTime }}
          </div>
        </div>
      </van-form>
      <div class="popup-footer">
        <van-button class="reset" type="info" block square @click="filterReset">{{
          $t.meta.reset
        }}</van-button>

        <van-button class="confirm" type="primary" block square @click="filterSubmit">{{
          $t.meta.confirm
        }}</van-button>
      </div>
    </van-popup>

    <van-popup v-model="showStartPicker" position="bottom">
      <van-datetime-picker
        type="date"
        :title="$t.meta.beginDate"
        :formatter="formatter"
        :confirm-button-text="$t.meta.confirm"
        :cancel-button-text="$t.meta.cancel"
        @confirm="dateChange($event, 'start')"
        @cancel="showStartPicker = false"
        :min-date="currentDate"
        v-model="selectDate"
      />
    </van-popup>

    <van-popup v-model="showEndPicker" position="bottom">
      <van-datetime-picker
        type="date"
        :title="$t.meta.endDate"
        :formatter="formatter"
        :confirm-button-text="$t.meta.confirm"
        :cancel-button-text="$t.meta.cancel"
        @confirm="dateChange($event, 'end')"
        @cancel="showEndPicker = false"
        :min-date="currentDate"
        v-model="selectDate"
      />
    </van-popup>

    <van-popup v-model="showStatePicker" round position="bottom">
      <van-picker
        :title="$t.vehicles.updateVehicleStatus"
        show-toolbar
        :columns="stateOptions"
        @confirm="stateConfirm"
        :confirm-button-text="$t.meta.confirm"
        @cancel="stateCancel"
        :cancel-button-text="$t.meta.cancel"
      />
    </van-popup>

    <van-dialog
      :title="$t.meta.notice"
      width="90%"
      v-model="showDeleteDialog"
      @confirm="deleteVehicles"
      @cancel="showDeleteDialog = false"
      :confirm-button-text="$t.meta.confirm"
      :cancel-button-text="$t.meta.cancel"
      :show-cancel-button="true"
      :show-confirm-button="true"
    >
      <div style="margin: 20px; text-align: center">
        {{ $t.meta.deleteConfirm }}
      </div>
    </van-dialog>

    <van-action-sheet v-model="sheetShow" :actions="sheetActions" @select="sheetSelect" />

    <div class="tool-bar">
      <van-button type="info" block @click="handleSheetShow">{{
        $t.meta.menu
      }}</van-button>
    </div>
  </div>
</template>

<script>
import {
  List,
  Row,
  Col,
  Search,
  Button,
  Icon,
  Form,
  Field,
  ActionSheet,
  Popup,
  DatetimePicker,
  Radio,
  RadioGroup,
  Checkbox,
  Picker,
} from "vant";

import Vue from "vue";
Vue.use(List)
  .use(Row)
  .use(Col)
  .use(Search)
  .use(Button)
  .use(Icon)
  .use(Form)
  .use(Field)
  .use(ActionSheet)
  .use(Popup)
  .use(DatetimePicker)
  .use(Radio)
  .use(RadioGroup)
  .use(Checkbox)
  .use(Picker);

export default {
  name: "vehiclesList",
  data() {
    return {
      page: 0,
      pageSize: 10,
      tableData: [],
      loading: false,
      finished: false,
      error: false,
      errorText: "",
      //filter
      searchText: "",
      searchType: 1,
      searchTypeOptions: [
        {
          text: this.$t.vehicles.plate,
          value: 1,
        },
        {
          text: this.$t.vehicles.vin,
          value: 2,
        },
      ],
      stateOptions: [
        {
          text: this.$t.vehicles.vStatus1,
          value: 1,
        },
        {
          text: this.$t.vehicles.vStatus2,
          value: 2,
        },
        {
          text: this.$t.vehicles.vStatus3,
          value: 3,
        },
        {
          text: this.$t.vehicles.vStatus4,
          value: 4,
        },
      ],
      vehicleStatus: null,
      showFilter: false,
      //日期
      selectDate: new Date(),
      currentDate: "",
      showStartPicker: false,
      beginTime: "",
      showEndPicker: false,
      endTime: "",
      //操作菜单
      checkedList: [],
      sheetShow: false,
      sheetActions: [],
      showStatePicker: false,
      //删除数据
      dialogDeleteId: "",
      showDeleteDialog: false,
    };
  },
  watch: {
    menuState() {
      this.loading = true;
      this.finished = false;
      this.error = false;
      this.tableData = [];
      this.checkedList = [];
      this.getList(1);
    },
  },
  created() {},
  methods: {
    stateCancel() {
      this.showStatePicker = false;
    },
    stateConfirm(e) {
      this.showStatePicker = false;
      this.batchUpdateVehicleStatusById(e.value);
    },
    sheetSelect(e) {
      if (e.className == "1") {
        if (this.checkedList.length == 0) {
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
            titleMsg: this.$t.vehicles.sheetNotice,
            type: "error",
          });
          return;
        }
        this.showStatePicker = true;
      }
      if (e.className == "2") {
        this.gotoDetail(null);
      }
      this.sheetShow = false;
    },
    onShowEmit(emit) {
      this.$bus.$emit(emit, true);
    },
    handleSheetShow() {
      var actions = [
        { name: this.$t.vehicles.updateVehicleStatus, className: "1" },
        { name: this.$t.vehicles.addVehicle, className: "2" },
      ];
      this.sheetActions = actions;
      this.sheetShow = true;
    },
    handleCheckBox() {
      var list = [];
      var items = this.tableData.filter((p) => p.isSelected);
      for (var item of items) {
        list.push(item.VehicleId);
      }
      this.checkedList = list;
    },
    gotoDetail(id) {
      this.$commonEnv.commonAction(this.$commonEnv.actionType.routerPush, {
        isParams: true,
        path: "vehiclesDetail",
        name: "vehiclesDetail",
        query: [
          {
            name: "VehicleId",
            value: id,
          },
        ],
      });
    },
    getPlaceHolder() {
      var search = this.searchTypeOptions.find((c) => c.value == this.searchType);
      if (search) {
        return search.text;
      } else {
        return this.$t.meta.searchText;
      }
    },
    onSearch() {
      this.initList();
      this.getList(1);
    },
    isFilter() {
      if (this.vehicleStatus || (this.beginTime && this.endTime)) {
        return true;
      } else {
        return false;
      }
    },
    filterReset() {
      this.searchText = "";
      this.searchType = 1;
      this.vehicleStatus = null;
      this.beginTime = "";
      this.endTime = "";
      this.initList();
      this.getList(1);
    },
    filterSubmit() {
      this.initList();
      this.getList(1);
    },
    initList() {
      this.loading = true;
      this.finished = false;
      this.error = false;
      this.showFilter = false;
      this.tableData = [];
    },
    showStartDate() {
      var start = new Date();
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 36500);
      this.currentDate = start;
      this.showStartPicker = true;
    },
    showEndDate() {
      var end = new Date();
      end.setTime(end.getTime() - 3600 * 1000 * 24 * 36500);
      this.currentDate = end;
      this.showEndPicker = true;
    },
    formatter(type, val) {
      if (type === "year") {
        return val + this.$t.meta.year;
      }
      if (type === "month") {
        return val + this.$t.meta.month;
      }
      if (type === "day") {
        return val + this.$t.meta.day;
      }
      return val;
    },
    dateChange(date, type) {
      var formatDate = (val) => {
        var time = new Date(val).toLocaleDateString();
        let [year, month, date] = time.split("/");
        if (month < 10) {
          month = "0" + month;
        }
        if (date < 10) {
          date = "0" + date;
        }
        return year + "-" + month + "-" + date;
      };
      if (type == "start") {
        this.beginTime = formatDate(date);
        this.showStartPicker = false;
      }
      if (type == "end") {
        this.endTime = formatDate(date);
        this.showEndPicker = false;
      }
    },
    getList(page) {
      return new Promise((resolve, reject) => {
        var param = {
          PageIndex: page,
          PageSize: this.pageSize,
          LicensePlate: this.searchType == 1 ? this.searchText : "",
          VIN: this.searchType == 2 ? this.searchText : "",
          VehicleStatus: this.vehicleStatus,
          BeginTime: this.beginTime,
          EndTime: this.endTime,
        };
        this.$api.storage
          .getVehiclesListByPage(param)
          .then((res) => {
            this.tableData = this.tableData.concat(res.data.Data);
            this.loading = false;
            this.error = false;
            this.errorText = "";

            this.page = res.meta.page;
            this.finished = this.page >= res.meta.lastPage;
            resolve(true);
          })
          .catch((error) => {
            this.loading = false;
            this.error = true;
            this.errorText = error.message;
            reject();
          });
      });
    },
    dialogDeleteShow(id) {
      this.dialogDeleteId = id;
      this.showDeleteDialog = true;
    },
    batchUpdateVehicleStatusById(status) {
      this.$commonMethod.showLoading();
      var param = {
        VehicleIdList: this.checkedList,
        VehicleStatus: status,
      };
      this.$api.storage
        .batchUpdateVehicleStatusById(param)
        .then((res) => {
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
            titleMsg: res.message,
            type: "success",
          });
          this.tableData = [];
          this.checkedList = [];
          this.getList(1);
          this.$commonMethod.hideLoading();
        })
        .catch((error) => {
          this.$commonMethod.hideLoading();
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
            msg: error.message,
          });
        });
    },
    deleteVehicles() {
      this.$commonMethod.showLoading();
      var param = {
        VehicleId: this.dialogDeleteId,
      };
      this.$api.storage
        .deleteVehicles(param)
        .then((res) => {
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
            titleMsg: res.message,
            type: "success",
          });
          this.tableData = [];
          this.checkedList = [];
          this.getList(1);
          this.$commonMethod.hideLoading();
        })
        .catch((error) => {
          this.$commonMethod.hideLoading();
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
            msg: error.message,
          });
        });
    },
  },
};
</script>
<style lang="scss" scoped>
@import "~assets/scss/var";
.vehiclesList {
  .searchTop {
    width: 100%;
    background-color: #ffffff;
    border-bottom: 1px solid #ebedf0;
    .search-top-row {
      width: 100%;
      text-align: center;
      background-color: transparent;
      .colItem1 {
        width: 80%;
        text-align: center;
        font-size: 14px;
        .van-search__content {
          padding: 0px;
          margin-right: 10px;
          .van-cell {
            padding: 5px 8px 5px 8px;
          }
        }
        .custom-date {
          padding: 10px;
          .date-btn1 {
            width: 40%;
            display: inline-block;
            border-right: 1px solid #ebedf0;
            line-height: 33px;
            vertical-align: middle;
          }
          .date-btn2 {
            width: 40%;
            display: inline-block;
            line-height: 33px;
            vertical-align: middle;
          }
          .van-button {
            vertical-align: middle;
          }
        }
      }
      .colItem2 {
        width: 20%;
        text-align: center;
        font-size: 14px;
        .isFilter {
          color: $-color-primary;
          font-weight: bold;
        }
      }
    }
  }
  .list {
    .list-container {
      font-size: 12px;
      color: #333;
      .checkBox {
        vertical-align: middle;
        display: inline-block;
        margin: 15px;
      }
      .container {
        box-shadow: 0px 1px 5px 1px rgba(0, 0, 0, 0.2);
        padding: 10px;
        .list-item {
          margin-bottom: 10px;
        }
        .list-item:last-child {
          margin-bottom: 0px;
        }
        .buttons {
          text-align: right;
          .primary-btn {
            margin-left: 5px;
            border-radius: 5px;
            background: $-color-primary;
            border: none;
            .van-button__text {
              font-size: 14px !important;
            }
          }
          .default-btn {
            margin-left: 5px;
            border-radius: 5px;
            background: $-color-light-gray;
            border: none;
            .van-button__text {
              font-size: 14px !important;
            }
          }
          .search-btn {
            margin-left: 5px;
            border-radius: 5px;
            background: $-color-green;
            border: none;
            .van-button__text {
              font-size: 14px !important;
            }
          }
          .danger-btn {
            margin-left: 5px;
            border-radius: 5px;
            background: $-color-red;
            border: none;
            .van-button__text {
              font-size: 14px !important;
            }
          }
        }
      }
    }
  }
  .popup-header {
    margin-top: 20px;
    margin-bottom: 10px;
    padding-bottom: 10px;
    text-align: center;
    font-size: 16px;
  }
  .radio-label {
    color: #646566;
    margin-bottom: 10px;
    font-size: 14px;
  }
  .van-radio-group {
    margin-bottom: 20px;
  }
  .van-radio {
    margin-bottom: 10px;
    font-size: 14px;
    ::v-deep .van-radio__label {
      color: #646566;
    }
  }
  .van-form {
    width: 90%;
    margin: auto;
    padding-bottom: 20vw;
    .van-cell:after {
      border: none;
    }
    .van-cell {
      border-bottom: 1px solid #ebedf0;
    }
    .custom-date {
      text-align: center;
      border-bottom: 1px solid #ebedf0;
      padding-bottom: 20px;
      .date-label {
        text-align: left;
        font-size: 14px;
        color: #646566;
        margin-left: 15px;
        margin-bottom: 10px;
        margin-top: 10px;
      }
      .date-btn1 {
        border-radius: 5px;
        color: white;
        border: none;
        vertical-align: middle;
        .van-button__text {
          font-size: 14px !important;
        }
      }
      .date-btn2 {
        margin-left: 30px;
        border-radius: 5px;
        color: white;
        border: none;
        vertical-align: middle;
        .van-button__text {
          font-size: 14px !important;
        }
      }
      .date-txt {
        margin-top: 20px;
        font-size: 14px;
        color: #999;
        border-radius: 10px;
      }
    }
  }
  .popup-footer {
    position: fixed;
    left: 0;
    bottom: 0;
    z-index: 100;
    background-color: white;
    padding-bottom: env(safe-area-inset-bottom);
    width: 100%;
    .reset {
      width: 50%;
      display: inline-block;
      color: $-color-primary;
      background: #ffffff;
      border: none;
    }
    .confirm {
      width: 50%;
      display: inline-block;
      color: #ffffff;
      background: $-color-primary;
      border: none;
    }
  }
  .tool-bar {
    box-sizing: border-box;
    position: fixed;
    left: 0;
    bottom: 0;
    width: 100%;
    background-color: white;
    z-index: 100;
    justify-content: space-between;
    padding-bottom: env(safe-area-inset-bottom);
    .van-button {
      border-radius: 0px;
    }
  }
  .taxInvoice-alert {
    overflow: scroll;
    height: 100vw;
    margin-top: 30px;
    .dialog-container {
      padding: 15px;
      font-size: 12px;
      color: #333;
      .dialog-item {
        margin-bottom: 10px;
      }
      .dialog-table {
        .dialog-table-label {
          margin-bottom: 10px;
        }
        .dialog-table-item {
          display: inline-block;
          width: 33.33%;
          text-align: center;
          margin-bottom: 10px;
          .item1 {
            padding: 10px;
            background: #1e90ff;
            color: #ffffff;
          }
          .item2 {
            padding: 10px;
            background: #e8f4ff;
          }
        }
        .dialog-radio-label {
          color: #333;
          margin-bottom: 10px;
          font-size: 12px;
        }
        .dialog-radio-group {
          margin-bottom: 10px;
        }
      }
    }
  }
}
</style>
